import React from 'react';
export function ProblemSection() {
  return <section className="w-full bg-[#f5f5f5] py-8 md:py-16 px-4 border-t-4 border-gray-300" data-id="element-233">
      <div className="max-w-3xl mx-auto" data-id="element-234">
        <div className="bg-white p-6 md:p-12 rounded-lg border-l-8 border-[#c41e3a] shadow-lg" data-id="element-235">
          <p className="text-xs md:text-sm text-[#c41e3a] font-black tracking-widest uppercase mb-3" data-id="element-236">
            Esto no es un curso más
          </p>
          <h2 className="text-2xl md:text-4xl font-black text-gray-900 mb-5 leading-tight" data-id="element-237">
            No estás comprando un curso.
          </h2>
          <p className="text-lg md:text-2xl font-black text-[#c41e3a] mb-6 leading-tight" data-id="element-238">
            Estás accediendo a un método estructurado diseñado para convertir la
            barbería en una habilidad profesional.
          </p>
          <div className="w-12 h-0.5 bg-[#c41e3a] mb-5" data-id="element-239"></div>
          <p className="text-sm md:text-lg text-gray-700 leading-relaxed mb-4" data-id="element-240">
            La diferencia entre cortar por intuición y trabajar como profesional
            no está en la máquina.
          </p>
          <p className="text-base md:text-xl text-gray-900 font-black" data-id="element-241">
            Está en el método.
          </p>
        </div>
      </div>
    </section>;
}